<div id="{{ id }}" class="mobile-slide bespoke-slide {{ classes }}">
    <div class="scroll">
        <div class="scroll__text">Scroll or use your keyboard to continue</div>
    </div>
    {{#if slide.title}}
        <h2>{{ slide.title }}</h2>
    {{/if}}

    <!--{{#if slide.bg_img}}
        <div class="media-outer">
            <img src="{{slide.bg_img}}" alt="" />
        </div>
    {{/if}}-->

    {{#if slide.poster}}
    <div class="media-outer">
        <img src="{{ poster(slide.poster) }}" alt="" />
    </div>
    {{/if}}

    {{#if slide.text}}
        <div>{{ slide.text }}</div>
    {{/if}}

    {{#if slide.text_list}}
        <div class="slide__bullet-group">
        {{#each slide.text_list as text_item, n}}
            <div class="slide__text slide__text--{{ n + 1 }} step">
            {{#if text_item.type == 'Text'}}
            <div class="slide__text-outer">
                <p class="slide__text-inner">{{ text_item.text }}</p>
            </div>
            {{elseif text_item.type == 'Video'}}
            <div class="slide__text-outer">
                <Modal slideIndex={{i}} modalIndex={{n}} modal={{text_item}} />
            </div>
            {{elseif text_item.type == 'Aside'}}
            <div class="slide__text-outer">
                <Modal slideIndex={{i}} modalIndex={{n}} modal={{$science_asides[text_item.slug]}} />
            </div>
            {{else}}
            <div class="slide__text-outer">
                <p class="slide__text-inner">{{ text_item }}</p>
            </div>
            {{/if}}
            </div>
        {{/each}}
            <span class="slide__text-bg"></span>
        </div>
    {{/if}}

    {{#if slide.modal }}
        {{#each slide.modal as modal, n}}
        <Modal slideIndex={{i}} modalIndex={{n}} :modal />
        {{/each}}
    {{/if}}
</div>

<script>
import Modal from '../../Modal.html'
import {poster} from '../../helpers'

export default {

    components: {
        Modal,
    },

    data() {
        return {
            slide: {},
            i: 0,
        }
    },

    computed: {
        id: slide => slide.slug ? slide.slug : slide._id,
        classes: ($current_slide, i) => {
            let classes = i == $current_slide ? 'bespoke-active' : 'bespoke-inactive';
            if (i < $current_slide) classes += ' bespoke-before'; 
            if (i > $current_slide) classes += ' bespoke-after';
            return classes;
        },
    },

    helpers: {
        poster,
    }
}
</script>